export default "__VITE_ASSET__BrfmStyn__"